<template>
  <Treeselect
    :options="options"
    :disableFuzzyMatching="true"
    :value="value"
    openDirection="below"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <label
      slot="option-label"
      slot-scope="{ node, labelClassName }"
      :title="node.label"
      :class="labelClassName"
    >
      {{ node.label }}
    </label>
  </Treeselect>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'MultiSelect',
  components: {
    Treeselect,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: [String, Number, Array],
  },
};
</script>
<style lang="scss">
.vue-treeselect {
  font-family: 'Nunito Sans', sans-serif !important;
  &:focus {
    outline: 0 !important;
  }
  &__control {
    height: 31px;
    border: 1px solid #bdc6cc;
    border-radius: 3px !important;
    &:focus {
      outline: 0 !important;
    }
    &-arrow {
      color: #c2c2c2;
    }
  }
  &--focused {
    .vue-treeselect__control {
      border-color: #3471f9;
      &-arrow {
        color: #3471f9;
      }
    }
    .vue-treeselect__x {
      color: #3471f9;
    }
  }
}
.vue-treeselect--open-below .vue-treeselect__menu {
  margin-top: 0px !important;
}
.vue-treeselect__label {
  color: #333;
  font-size: 14px;
  line-height: 1.36;
  padding: 7px 8px;
}

.vue-treeselect__checkbox-container {
  padding-top: 10px !important;
}
.vue-treeselect__option--highlight {
  background-color: #ebf0f3;
}
.vue-treeselect__menu {
  border-color: #bdc6cc;
  border-radius: 3px !important;
}

.vue-treeselect__value-container {
  height: 31px;
}

.vue-treeselect--disabled .vue-treeselect__control {
  background-color: #e9ecef;
  cursor: not-allowed;
}
.vue-treeselect__checkbox-container {
  padding-top: 2px !important;
}
</style>
